import type { ArticleType } from '../schemas/article';

export interface PaginatedArticleListQuery {
  type: ArticleType;
  pageSize: number;
  offset: number;
  /** Request one extra row to detect hasMore without a separate count query. */
  probeHasMore?: boolean;
}

/** Builds `/api/articles` list URLs with offset pagination (marketing site). */
export function buildPaginatedArticleListUrl({
  type,
  pageSize,
  offset,
  probeHasMore = true,
}: PaginatedArticleListQuery): string {
  const limit = probeHasMore ? pageSize + 1 : pageSize;
  const search = new URLSearchParams({
    type,
    limit: String(limit),
    offset: String(offset),
  });
  return `/api/articles?${search.toString()}`;
}
